import  gql  from 'graphql-tag'

export const SHARE_FM100_EMAIL = gql`mutation shareFm100ByEmail($input: ShareFM100ByEmailMutationInput!){
    shareFm100ByEmail(input: $input){
        errors{
            field
            messages
        }
    }
}`;